import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';

import iconSrc from '../../../utils/iconSrc';
/** Can't include other assemblies in provided results */
import RichText from '../../rich-text/base';
import LinkHandler from '../../link-handler';
import Button from '../../button';

import { Heading } from './styles';

const StyledSVG = styled(SVG)`
  display: inline-block;
  margin-right: ${({ theme }) => theme.spacing.tiny};
  fill: ${({ theme }) => theme.palette.royalBlue};
  width: 1em;
  height: 1em;
`;

const Section = styled.p`
  font-weight: 700;
`;

/**
 * Provides results for a Generic Result service lookup
 */
const GenericResult = ({
  council,
  phone,
  oooPhone,
  email,
  link = {},
  address,
  additionalAnswerText = {},
  text,
  downloadURL,
}) => {
  if (!council) return null;

  return (
    <>
      <Heading>Your local council is {council}</Heading>

      {downloadURL && (
        <p>
          <Button as="a" bg="primary" href={downloadURL}>
            Download file
          </Button>
        </p>
      )}

      {(phone || oooPhone) && (
        <Section>
          <StyledSVG src={iconSrc('telephone')} />
          Telephone
        </Section>
      )}
      {phone && (
        <p>
          <strong>
            <a href={`tel: ${phone}`}>{phone}</a>
          </strong>
        </p>
      )}
      {oooPhone && (
        <p>
          <strong>
            <a href={`tel: ${oooPhone}`}>{oooPhone}</a>
          </strong>{' '}
          (Out of hours)
        </p>
      )}

      {email && (
        <>
          <Section>
            <StyledSVG src={iconSrc('envelope')} /> Email
          </Section>
          <p>
            <LinkHandler link={{ external: true, URL: `mailto:${email}` }}>
              {email}
            </LinkHandler>{' '}
            Email your council
          </p>
        </>
      )}

      {address && (
        <>
          <Section>
            <StyledSVG src={iconSrc('map-marker')} />
            Address
          </Section>
          <p>
            <strong>Your local housing office is:</strong>
          </p>
          <p>
            {address.split(',').map((l, i) => (
              <Fragment key={i}>
                {l}
                <br />
              </Fragment>
            ))}
          </p>
          <p>
            <a href={`https://www.google.com/maps?daddr=${address}`}>
              Get directions on Google Maps
            </a>
          </p>
        </>
      )}

      {Object.keys(text).length ? <RichText richText={text} /> : null}

      {link && (
        <p>
          <LinkHandler link={link}>
            Find out more about housing services in your local area
          </LinkHandler>
        </p>
      )}
      {Object.keys(additionalAnswerText).length ? (
        <RichText richText={additionalAnswerText} />
      ) : null}
    </>
  );
};

GenericResult.propTypes = {
  /** The Council name */
  council: PropTypes.string.isRequired,
  /** In hours main phone */
  phone: PropTypes.string,
  /** Out of Hours phone */
  oooPhone: PropTypes.string,
  email: PropTypes.string,
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  address: PropTypes.string,
  downloadURL: PropTypes.string,
  text: PropTypes.object,
  additionalAnswerText: PropTypes.object,
};

export default GenericResult;
